import React, { Component } from "react";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t
} from "../../components/CustomComponent.js"; 

export default class FinanceMasters extends Component {
  isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  };

  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      
      count: 0,
      page: 1,

      // Modal States
      modal_create: false,
      modal_update: false,
      modal_view: false,
      
      // Form States (อิงตาม API Payload ของ finance-masters)
      uid: "", 
      company_id: company?.id,
      finance_name_th: "", 
      finance_name_en: "", 
      type: "", 
      name_th: "", 
      name_en: "", 
      phone: "", 
      email: "", 
      line_id: "", 
      website: "", 
      address: "", 
      province: "", 
      district: "", 
      sub_district: "", 
      zip_code: "", 
      remark: "", 
      status: "Active", // จัดการ is_active (boolean)

      financeData: null, // สำหรับเปิดดูข้อมูล Modal View
      data: []
    };
  }

  async componentDidMount() {
    this.Get(1);
  }

  // ดึงข้อมูล Finance Masters
  Get = async (page) => {
    const { filter_search } = this.state;
    loading(true);

    let [result] = await Promise.all([ 
      GET("admin/finance-masters", { 
        page_size: 10, 
        page: page, 
        data_search: filter_search || "",
        uid: ""
      }),
    ]);

    if (result?.status) {
      this.setState({ 
        data: result.data || [], 
        count: result.pagination?.count || 0,
        page: page
      });
    }

    loading(false);
  };

  // สร้างหรือแก้ไขข้อมูล Finance Masters
  CreateUpdate = async () => {
    const {
      uid, company_id, finance_name_th, finance_name_en, type, name_th, name_en, 
      phone, email, line_id, website, address, province, district, sub_district, 
      zip_code, remark, status
    } = this.state;
    const normalizedEmail = (email || "").trim();

    // Validate เบื้องต้น
    if (!finance_name_th?.trim()) {
      alert("", "warning", t("warning"), t("validate_finance_name_th"));
      return;
    } else if (!phone?.trim()) {
      alert("", "warning", t("warning"), t("validate_sale_phone"));
      return;
    } else if (normalizedEmail && !this.isValidEmail(normalizedEmail)) {
      alert("", "warning", t("warning"), t("invalid_email_address"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      
      // Map state ให้ตรงกับ API Payload ของ Finance Masters
      let body = {
        company_id: company_id,
        finance_name_th: finance_name_th,
        finance_name_en: finance_name_en,
        type: type,
        name_th: name_th,
        name_en: name_en,
        phone: phone,
        email: normalizedEmail,
        line_id: line_id,
        website: website,
        address: address,
        province: province,
        district: district,
        sub_district: sub_district,
        zip_code: zip_code,
        remark: remark,
        is_active: status === "Active" ? true : false
      };

      let result = !uid
        ? await POST("admin/finance-masters", body)
        : await PUT("admin/finance-masters/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page); // โหลดข้อมูลใหม่
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  // ลบข้อมูล
  Delete = async (id) => {
    if(!id) return;
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("admin/finance-masters/" + id, null);
      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_update: false });
        this.Get(1);
      } else {
        alert("", "warning", t("warning"), result?.message || t("cannot_delete_item"));
      }
      loading(false);
    }
  };

  // ฟังก์ชันช่วยจัดการข้อมูลตอนกดเปิด Modal แก้ไข
  handleEditClick = (item) => {
    this.setState({ 
      modal_update: true, 
      uid: item.uid || item.id,
      finance_name_th: item.finance_name_th || "",
      finance_name_en: item.finance_name_en || "",
      type: item.type || "",
      name_th: item.name_th || "",
      name_en: item.name_en || "",
      phone: item.phone || "",
      email: item.email || "",
      line_id: item.line_id || "",
      website: item.website || "",
      address: item.address || "",
      province: item.province || "",
      district: item.district || "",
      sub_district: item.sub_district || "",
      zip_code: item.zip_code || "",
      remark: item.remark || "",
      status: item.is_active !== false ? "Active" : "Inactive",
    });
  }

  // ฟังก์ชันรีเซ็ต Form
  handleCreateClick = () => {
    this.setState({
      modal_create: true,
      uid: "",
      finance_name_th: "", finance_name_en: "", type: "", name_th: "", name_en: "", 
      phone: "", email: "", line_id: "", website: "", address: "", province: "", 
      district: "", sub_district: "", zip_code: "", remark: "", status: "Active",
    });
  }

  render() {
    const { 
      data, count, filter_search, page,
      modal_create, modal_update, modal_view, financeData,
      // Form fields
      uid, finance_name_th, finance_name_en, type, name_th, name_en, phone, email, 
      line_id, website, address, province, district, sub_district, zip_code, remark, status
    } = this.state;
    const emailHasError = Boolean((email || "").trim()) && !this.isValidEmail(email || "");

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("finance_masters")}</h3>
                        <div className="text-secondary text-14">{t("finance_masters_desc")}</div>
                    </div>
                    <button className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" onClick={this.handleCreateClick}>
                        <span className="me-2 text-16">+</span> {t("create_new")}
                    </button>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap align-items-center gap-3">
                        <div className="position-relative flex-grow-1" style={{ maxWidth: "350px" }}>
                            <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                            <input
                                type="text"
                                className="form-control ps-5 wpx-350"
                                placeholder={t("search_finance_placeholder")}
                                value={filter_search}
                                onChange={(e) => this.setState({ filter_search: e.target.value })}
                                onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                            />
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm overflow-hidden">
                    {/* Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 px-2 border-0 wpx-300">{t("finance_name")}</th>
                                    <th className="py-3 border-0">{t("contact_person")}</th>
                                    <th className="py-3 border-0">{t("contact_channel")}</th>
                                    <th className="py-3 border-0 text-center">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item, idx) => (
                                        <tr key={idx} className="border-bottom border-light">
                                            <td className="py-3 px-2">
                                                <div className="d-flex align-items-center">
                                                    <div className={`wpx-40 hpx-40 rounded-3 d-flex align-items-center justify-content-center me-3 flex-shrink-0 bg-primary-light text-primary`}>
                                                        <span className="icon text-16">{"\uf19c"}</span>
                                                    </div>
                                                    <div>
                                                        <div className="fw-bold text-dark text-14">{item.finance_name_th || "-"}</div>
                                                        <div className="text-secondary text-12">{item.finance_name_en || "-"}</div>
                                                        {item.type && <div className="text-secondary text-10 mt-1">{t("type")}: {item.type}</div>}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-dark text-14">{item.name_th || "-"}</div>
                                                <div className="text-secondary text-12">{item.name_en || "-"}</div>
                                            </td>
                                            <td>
                                                <div className="fw-bold text-dark text-14">{item.phone || "-"}</div>
                                                <div className="text-secondary text-12">{item.email || "-"}</div>
                                            </td>
                                            <td className="text-center">
                                                {item.is_active !== false ? (
                                                    <span className="badge bg-success-light text-success rounded-pill px-3 py-1 fw-bold text-10 border border-success">{t("active")}</span>
                                                ) : (
                                                    <span className="badge bg-secondary-light text-secondary rounded-pill px-3 py-1 fw-bold text-10 border border-secondary">{t("inactive")}</span>
                                                )}
                                            </td>
                                            <td className="text-center">
                                                <div className="d-flex justify-content-center gap-3 text-secondary text-16">
                                                    <span className="icon pointer hover-primary transition-hover" onClick={() => this.setState({ financeData: item, modal_view: true })}>
                                                        {"\uf06e"}
                                                    </span>
                                                    <span className="icon pointer hover-primary transition-hover" onClick={() => this.handleEditClick(item)}>
                                                        {"\uf044"}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" className="text-center py-4 text-secondary">
                                            {t("no_data_found")}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} 1-{data.length} {t("of")} {count} {t("items")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, p) => this.Get(p)} />
                </div>
            </div>

            {/* CREATE / UPDATE MODAL */}
            <Modal size="xl" show={modal_create || modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })} centered>
                {/* Custom Header */}
                <div className="modal-header border-bottom bg-white d-flex justify-content-between align-items-center py-3 px-4">
                    <div className="d-flex align-items-center">
                        <span className="icon text-primary text-24 me-2">{"\uf19c"}</span>
                        <h4 className="fw-bold mb-0 text-dark" style={{ color: "#2B3674" }}>
                            {t("finance_master_form_title")}
                        </h4>
                        <span className="text-primary mx-2">•</span>
                        <span className="text-primary fw-medium text-14">{modal_create ? t("create_new") : t("edit_data")}</span>
                    </div>
                    <div className="d-flex align-items-center">
                        <span className="badge bg-success-light text-success px-3 py-1 rounded-pill border border-success d-flex align-items-center">
                            <div className="rounded-circle bg-success me-1" style={{ width: "6px", height: "6px" }}></div> {status === "Active" ? t("active") : t("inactive")}
                        </span>
                    </div>
                </div>

                <Modal.Body className="p-4" style={{ backgroundColor: "#F4F7FE" }}>
                    {/* Section 1: ข้อมูลสถาบันการเงิน */}
                    <div className="card border-0 shadow-sm rounded-4 mb-4">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-4 pb-2 border-bottom" style={{ color: "#2B3674" }}>
                                <span className="text-primary me-2">•</span>{t("finance_information")}
                            </h6>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("finance_name_th_label")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("finance_name_th_placeholder")}
                                        value={finance_name_th}
                                        onChange={(e) => this.setState({ finance_name_th: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("finance_name_en_label")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("finance_name_en_placeholder")}
                                        value={finance_name_en}
                                        onChange={(e) => this.setState({ finance_name_en: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("type")}</label>
                                    <select type="text" className="form-select" placeholder={t("finance_type_placeholder")} value={type} onChange={(e) => this.setState({ type: e.target.value })}>
                                        <option value="">{t("select_type")}</option>
                                        <option value="Bank">Bank</option>
                                        <option value="Non-Bank">Non-Bank</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 2: ข้อมูลผู้ติดต่อและการสื่อสาร */}
                    <div className="card border-0 shadow-sm rounded-4 mb-4">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-4 pb-2 border-bottom" style={{ color: "#2B3674" }}>
                                <span className="text-primary me-2">•</span>{t("contact_information")}
                            </h6>
                            <div className="row g-3">
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("contact_name_th_label")}</label>
                                    <input type="text" className="form-control" placeholder={t("full_name")} value={name_th} onChange={(e) => this.setState({ name_th: e.target.value })} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("contact_name_en_label")}</label>
                                    <input type="text" className="form-control" placeholder={t("contact_name_en_placeholder")} value={name_en} onChange={(e) => this.setState({ name_en: e.target.value })} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("line_id")}</label>
                                    <input type="text" className="form-control" placeholder={t("line_id_placeholder")} value={line_id} onChange={(e) => this.setState({ line_id: e.target.value })} />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">
                                        {t("phone")} <span className="text-danger">*</span>
                                    </label>
                                    <input type="text" className="form-control" placeholder={t("finance_phone_placeholder")} maxLength={10} value={phone} onChange={(e) => this.setState({ phone: e.target.value })} />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("email")}</label>
                                    <input
                                        type="email"
                                        className={`form-control${emailHasError ? " is-invalid" : ""}`}
                                        placeholder={t("finance_email_placeholder")}
                                        value={email || ""}
                                        onChange={(e) => this.setState({ email: e.target.value })}
                                    />
                                    {emailHasError && <div className="invalid-feedback">{t("invalid_email_address")}</div>}
                                </div>
                                {/* <div className="col-md-4">
                      <label className="form-label text-12 fw-bold text-secondary mb-1">Line ID</label>
                      <input type="text" className="form-control" placeholder="Line ID" value={line_id} onChange={(e) => this.setState({ line_id: e.target.value })} />
                   </div> */}
                                <div className="col-md-4">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("website")}</label>
                                    <input type="text" className="form-control" placeholder={t("website_placeholder")} value={website} onChange={(e) => this.setState({ website: e.target.value })} />
                                </div>

                                <div className="col-12 mt-3">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("address")}</label>
                                    <textarea
                                        className="form-control"
                                        rows="2"
                                        placeholder={t("finance_address_placeholder")}
                                        value={address}
                                        onChange={(e) => this.setState({ address: e.target.value })}
                                    ></textarea>
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("province")}</label>
                                    <input type="text" className="form-control" placeholder={t("province")} value={province} onChange={(e) => this.setState({ province: e.target.value })} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("district")}</label>
                                    <input type="text" className="form-control" placeholder={t("district")} value={district} onChange={(e) => this.setState({ district: e.target.value })} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("sub_district")}</label>
                                    <input type="text" className="form-control" placeholder={t("sub_district")} value={sub_district} onChange={(e) => this.setState({ sub_district: e.target.value })} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("postal_code")}</label>
                                    <input type="text" className="form-control" placeholder={t("postal_code_placeholder")} maxLength={5} value={zip_code} onChange={(e) => this.setState({ zip_code: e.target.value })} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section 3: การตั้งค่าระบบ */}
                    <div className="card border-0 shadow-sm rounded-4 mb-2">
                        <div className="card-body p-4">
                            <h6 className="fw-bold text-dark mb-4 pb-2 border-bottom" style={{ color: "#2B3674" }}>
                                <span className="text-primary me-2">•</span>{t("remark_and_status")}
                            </h6>
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label text-12 fw-bold text-secondary mb-1">{t("note_additional")}</label>
                                    <textarea
                                        className="form-control"
                                        rows="2"
                                        placeholder={t("note_placeholder")}
                                        value={remark}
                                        onChange={(e) => this.setState({ remark: e.target.value })}
                                    ></textarea>
                                </div>

                                {/* Status */}
                                <div className="col-12 mt-2 border-top pt-4">
                                    <h6 className="fw-bold mb-1 d-flex align-items-center">
                                        <span className="icon text-primary me-2">{"\uf772"}</span> {t("usage_status")}
                                    </h6>
                                    <div className="d-flex gap-4 mt-3">
                                        <div className="form-check d-flex align-items-center gap-2">
                                            <input
                                                className="form-check-input mt-0 pointer"
                                                type="radio"
                                                name="financeStatus"
                                                id="statusActive"
                                                checked={status === "Active"}
                                                onChange={() => this.setState({ status: "Active" })}
                                            />
                                            <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                                {t("active_with_en")}
                                            </label>
                                        </div>
                                        <div className="form-check d-flex align-items-center gap-2">
                                            <input
                                                className="form-check-input mt-0 pointer"
                                                type="radio"
                                                name="financeStatus"
                                                id="statusInactive"
                                                checked={status === "Inactive"}
                                                onChange={() => this.setState({ status: "Inactive" })}
                                            />
                                            <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                                {t("inactive_with_en")}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                {/* Custom Footer */}
                <Modal.Footer className="border-top p-3 bg-white d-flex justify-content-between">
                    <div>
                        {modal_update && (
                            <button onClick={() => this.Delete(uid)} className="btn btn-outline-danger px-4 d-flex align-items-center bg-white border-danger text-danger">
                                <span className="icon me-2 text-14">{"\uf2ed"}</span> {t("delete_data")}
                            </button>
                        )}
                    </div>
                    <div className="d-flex gap-2">
                        <button className="btn btn-outline-secondary px-4 bg-white" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                            <span className="icon me-2 text-14">{"\uf00d"}</span> {t("cancel")}
                        </button>
                        <button className="btn btn-primary px-4 d-flex align-items-center" onClick={this.CreateUpdate} style={{ backgroundColor: "#2B3674", borderColor: "#2B3674" }}>
                            <span className="icon me-2 text-14">{"\uf00c"}</span> {t("save")}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* VIEW MODAL */}
            <Modal size="lg" show={modal_view} onHide={() => this.setState({ modal_view: false })} centered>
                <Modal.Header className="border-bottom" closeButton>
                    <h5 className="fw-bold mb-0">{t("finance_details")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4">
                    {financeData && (
                        <div className="row">
                            <div className="col-12 mb-3">
                                <h5 className="fw-bold text-dark mb-1">{financeData.finance_name_th}</h5>
                                <p className="text-secondary mb-0">{financeData.finance_name_en || "-"}</p>
                            </div>
                            <div className="col-md-6 mb-2">
                                <strong>{t("type")}:</strong> {financeData.type || "-"}
                            </div>
                            <div className="col-md-6 mb-2">
                                <strong>{t("website")}:</strong> {financeData.website || "-"}
                            </div>

                            <div className="col-12 mt-3 mb-2 border-top pt-3">
                                <h6 className="fw-bold text-primary">{t("contact_info")}</h6>
                            </div>
                            <div className="col-md-6 mb-2">
                                <strong>{t("finance_contact_name")}:</strong> {financeData.name_th || "-"} {financeData.name_en ? `(${financeData.name_en})` : ""}
                            </div>
                            <div className="col-md-6 mb-2">
                                <strong>{t("phone")}:</strong> {financeData.phone || "-"}
                            </div>
                            <div className="col-md-6 mb-2">
                                <strong>{t("email")}:</strong> {financeData.email || "-"}
                            </div>
                            <div className="col-md-6 mb-2">
                                <strong>{t("line_id")}:</strong> {financeData.line_id || "-"}
                            </div>

                            <div className="col-12 mt-2">
                                <strong>{t("address")}:</strong> {financeData.address} {financeData.sub_district} {financeData.district} {financeData.province} {financeData.zip_code}
                            </div>
                            <div className="col-12 mt-2">
                                <strong>{t("note_label")}:</strong> {financeData.remark || "-"}
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-top bg-white p-3 d-flex justify-content-end">
                    <button className="btn btn-outline-secondary px-4 me-2" onClick={() => this.setState({ modal_view: false })}>
                        ปิด
                    </button>
                    <button
                        className="btn btn-primary px-4 d-flex align-items-center"
                        onClick={() => {
                            this.setState({ modal_view: false });
                            this.handleEditClick(financeData);
                        }}
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                    >
                        <span className="icon me-2">{"\uf044"}</span> แก้ไข
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
